'use client'

import { COOKIE_POST_LOGIN_REDIRECT } from "../consts"

// Utilities to resolve and clear the post-login redirect target.

function getFromQuery(): string | null {
  if (typeof window === 'undefined') return null
  try {
    const params = new URLSearchParams(window.location.search)
    const val = params.get('returnTo')
    return val ?? null
  } catch {
    return null
  }
}

function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null
  const parts = document.cookie ? document.cookie.split('; ') : []
  for (const part of parts) {
    const [k, ...rest] = part.split('=')
    if (k === name) {
      return rest.join('=') || ''
    }
  }
  return null
}

function isSafeInternalPath(path: string): boolean {
  if (!path) return false
  if (!path.startsWith('/')) return false
  // Prevent protocol-relative URLs like //evil.com
  if (path.startsWith('//')) return false
  return true
}

export function getPostLoginRedirect(fallback: string = '/'): string {
  let raw = getFromQuery()
  if (!raw) {
    raw = getCookie(COOKIE_POST_LOGIN_REDIRECT)
  }

  if (!raw) return fallback

  let decoded = raw
  try {
    decoded = decodeURIComponent(raw)
  } catch {
    // if decoding fails, use raw
  }

  if (isSafeInternalPath(decoded)) return decoded
  return fallback
}

export function clearPostLoginRedirect(): void {
  if (typeof document === 'undefined') return
  // Clear cookie immediately
  const hostname = window.location.hostname
  const domain =
    hostname.endsWith('.happy-health.net') ? '; Domain=.happy-health.net' : ''
  document.cookie = `${COOKIE_POST_LOGIN_REDIRECT}=; Max-Age=0; path=/; SameSite=Lax${domain}`
}
